import { Controller } from "@hotwired/stimulus";

let select2Loaded = false;

export default class Select2Controller extends Controller {
  static targets = [
    "selectBackskin",
    "selectAnalytics",
    "moveFolder",
    "selectInterest",
  ];
  static values = {
    frameId: { type: String },
  };
  selected = [];

  async connect() {
    if ($(this.element).hasClass("select2-hidden-accessible")) {
      $(this.element).parent()?.find(".select2-container--default")?.remove();
    }
    await this.loadSelect2();
    this.initSelect2();
  }

  async loadSelect2() {
    if (select2Loaded) return;

    const module = await import("select2");
    const select2 = module.default || module;

    select2($);
    select2Loaded = true;
  }

  initSelect2() {
    const $element = $(this.element);
    const $dropdownParent =
      this.hasFrameIdValue && this.frameIdValue.trim() !== ""
        ? this.element.closest(`${this.frameIdValue}`)
        : $element.parent();
    const dropdownOptions = {
      placeholder: this.hasSelectBackskinTarget
        ? "Select"
        : this.element.dataset.placeholder || "Search Interest",
      dropdownParent: $dropdownParent,
    };
    if (["custom_lang", "message_custom_lang"].includes(this.element.id)) {
      dropdownOptions.language = {
        noResults: () => this.element.dataset.languagesLoading === "1"
          ? "Loading languages…"
          : "No results found",
      };
    }
    if (this.element.dataset.closeOnSelect === "false") {
      dropdownOptions.closeOnSelect = false;
    }
    if (this.element.dataset.searchByCode === "true") {
      dropdownOptions.matcher = (params, data) => {
        const term = $.trim(params.term).toLowerCase();

        if (!term) return data;

        const text = (data.text || "").toLowerCase();
        const value = (data.id || "").toLowerCase();

        return text.includes(term) || value.includes(term)
          ? data
          : null;
      };
    }

    $element
      .select2(dropdownOptions)
      .on("select2:open", () => {
        const modalBody = $element.closest(".modal-body");
        if (modalBody.length) {
          if (modalBody.length) {
            if (modalBody.data("original-overflow") === undefined) {
              modalBody.data("original-overflow", modalBody.css("overflow-y"));
            }
            modalBody.css("overflow-y", "hidden");
          }
        }
        if (this.element.dataset.filterRemoved === "true") {
          this.searchDisabled();
        }
        setTimeout(() => {
          const searchInput = document.querySelector(
            ".select2-container--open .select2-search__field",
          );
          if (this.element.dataset.resetScrollOnOpen === "true") {
            const results = document.querySelector(
              ".select2-container--open .select2-results__options",
            );
            if (results) results.scrollTop = 0;
          }
          // if (searchInput) searchInput.blur();

          // set placeholder in the languge select tag
          const placeholder = this.element.dataset.placeholder;
          if (placeholder && this.element.id === "custom_lang") {
            searchInput.placeholder = placeholder;
          }
        }, 0);
      })
      .on("select2:close", (e) => {
        const modalBody = $element.closest(".modal-body");
        if (this.element.dataset.filterRemoved === "true") {
          this.searchDisabled();
        }

        if ($(".select2-container--open").length) {
          return; // another Select2 is still open
        }

        if (modalBody.length) {
          const originalOverflow =
            modalBody.data("original-overflow") || "auto";
          modalBody.css("overflow", originalOverflow);
        }
      })
      .on("select2:select", (e) => {
        // Clear the search input
        const searchInput = document.querySelector(
          ".select2-container--open .select2-search__field",
        );
        if (searchInput) {
          searchInput.value = "";
          searchInput.dispatchEvent(new Event("input", { bubbles: true }));
        }

        this.element.dispatchEvent(new Event("change", { bubbles: true }));
        if (this.hasSelectAnalyticsTarget) {
          this.handleSubmitSelection(e);
          return;
        }
        if (this.hasMoveFolderTarget) {
          this.handleFolderSelection(e);
          return;
        }
        if (this.element.dataset.analyticsChart === "true") {
          this.handleUpdateChart();
          return;
        }
        if (this.hasSelectInterestTarget) {
          this.fetchData();
        }
      })
      .on("select2:selecting", (e) => {
        const maxSelection = parseInt(this.element.dataset.maxSelection, 10);
        if (!maxSelection) return;

        const selectedValues = $(this.element).val() || [];
        if (selectedValues.length >= maxSelection) {
          e.preventDefault();

          const errorElement = document.querySelector(".language_error");
          if (!errorElement) return;

          errorElement.innerHTML = `You can select up to ${maxSelection} languages.`;
          setTimeout(() => {
            $(this.element).select2("close");
          }, 0);
        }
      })
      .on("select2:unselect", (e) => {
        const maxSelection = parseInt(this.element.dataset.maxSelection, 10);
        const selectedValues = $(this.element).val() || [];

        if (selectedValues.length < maxSelection) {
          const errorElement = document.querySelector(".language_error");
          if (errorElement) {
            errorElement.innerHTML = "";
          }
        }
        this.element.dispatchEvent(new Event("change", { bubbles: true }));
        if (this.hasSelectAnalyticsTarget) {
          this.handleSubmitSelection(e);
          return;
        }
        if (this.element.dataset.analyticsChart === "true") {
          this.handleUpdateChart();
          return;
        }
        if (this.hasSelectInterestTarget) {
          this.fetchData();
        }
      });
  }

  async handleSubmitSelection(e) {
    const value = e.target.value;
    const url = new URL(this.element.dataset.url, globalThis.location.origin);
    url.searchParams.set("range", value);

    const turboRequest = await this.loadTurboRequest();

    await turboRequest(url, {
      method: "GET",
      turboStream: true,
    });
  }

  async handleUpdateChart() {
    const status = document.getElementById("analytics-bar-status")?.value;
    const year = document.getElementById("analytics-bar-details")?.value;
    const url = new URL(this.element.dataset.url, globalThis.location.origin);

    url.searchParams.set("year", year);
    url.searchParams.set("status", status);
    const turboRequest = await this.loadTurboRequest();

    await turboRequest(url, {
      method: "get",
      turboStream: true,
    });
  }

  handleFolderSelection(e) {
    let form = $(this.element).closest("form");
    form[0].requestSubmit();
  }

  fetchData() {
    // remove the selected option from select field and show the placeholder again
    $(".select2-selection__choice").remove();
    $(".select2-search__field")
      .attr("placeholder", "Select Interest")
      .removeAttr("style");

    let form = $(this.element).closest("form");
    form[0].requestSubmit();
  }

  searchDisabled() {
    const searchTextarea = document.querySelector(".select2-search__field");
    searchTextarea.setAttribute("disabled", "disabled");
  }

  async loadTurboRequest() {
    const turboRequest = (await import("../helpers/api")).turboRequest;
    return turboRequest;
  }
}
